// extracted by mini-css-extract-plugin
export default {"simple":"simple-aL_c"};